<template>
	<div style="width: 100%;height: 100%;">
		<div v-if="!RegisterSuccess&&!RegisterWarning" style="width: 100%;height: 100%;">
			<div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 30px;">
				<Icon size="120" color="#5cadff" type="ios-time" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 22px;">
				您确定签到此会议嘛?
			</div>
			<Row type="flex" justify="center" align="middle" style="margin-top: 12rem;">
				<Col span="2">
				</Col>
				<Col span="20">
					<Button style="margin-bottom: 12px;" type="success" long>确定</Button>
					<Button long>取消</Button>
				</Col>
				<Col span="2">
				</Col>
			</Row>
		</div>
		<div v-if="RegisterWarning" style="width: 100%;height: 100%;">
			<div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 30px;">
				<Icon size="120" color="#ed4014" type="ios-alert" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 22px;">
				{{WarningMsg.address}}
			</div>
		</div>
		<div v-if="RegisterSuccess" style="width: 100%;height: 100%;padding-top: 30px;">
			<div style="width: 100%;margin: 0 auto;text-align: center;">
				<Icon size="120" color="#10b910" type="ios-checkmark-circle" />
			</div>
			<div style="width: 100%;height: 38px;margin: 0 auto;text-align: center;font-size: 28px;">
				签到成功
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				RegisterSuccess:true,
				RegisterWarning:false,
				WarningMsg:{
					address:'签到地点错误',
					noMeetingPerson:'非参会人员'
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Meeting/Register/index.vue